// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const collapsibleStyles = css`
  ${(props) =>
    props.isMobileOtherLoactions
      ? `border-top: none;
      border-bottom: none;`
      : `border-top: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
      border-bottom: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};`};

  .collapsible-header {
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    padding-top: ${(props) =>
      props.isMobileOtherLoactions ? '0' : props.theme.spacing.LAYOUT_SPACING.XS};
    padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
    background: none;

    &[aria-expanded='true'] {
      padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.XXS};
    }
    > div {
      flex: 1;
      text-align: left;
    }
  }

  .collapsible-icon {
    top: 28px;
  }

  .collapsible-content {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.body.small.secondary}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    line-height: ${(props) => props.theme.fonts.lineHeight.normal};
    color: ${(props) => props.theme.colors.TEXT.DARK};
    padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
  }
`;

export const tileStyles = css`
  height: 100%;
  box-sizing: border-box;
  border-bottom: ${(props) => props.isStoreDetailsRedesignMobileEnabled && `none`};
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    border: none;
  }
  .store-details-header {
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      width: 190px;
    }
  }
  .store-name {
    &--details {
      font-family: ${(props) => props.theme.fonts.secondaryFontBlackFamily};
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
      line-height: ${(props) => props.theme.fonts.lineHeight.normal};
    }
  }
  .store-type {
    display: none;
  }
  .tile-footer {
    padding-top: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? 0
        : props.theme.spacing.ELEM_SPACING.LRG};
  }
`;

export default css`
  padding-top: ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
  padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
  .locations-title {
    font-family: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled
        ? props.theme.fonts.secondaryFontFamily
        : props.theme.brandSpecificStyles.JOIN_OUR_TEXT_ALERTS_FONT};
    ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled &&
      `
        font-size: ${props.theme.fonts.fontSize.body.bodytext.copy8}px;
       font-weight: ${props.theme.fonts.fontWeight.bold};
        `}
    color: ${(props) => props.theme.colors.TEXT.DARK};
    text-transform: capitalize;
    margin-top: 0;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .location__lg {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  .location__sm {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
  }
  .collapsible-header-text {
    font-family: ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled
        ? props.theme.fonts.secondaryFontFamily
        : props.theme.brandSpecificStyles.JOIN_OUR_TEXT_ALERTS_FONT};
    ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled &&
      `
    font-size: ${props.theme.fonts.fontSize.body.bodytext.copy6}px;
    font-weight: ${props.theme.fonts.fontWeight.bold};
    text-transform: capitalize;

    `}
  }
  .other-stores {
    display: grid;
    @media ${(props) => props.theme.mediaQuery.desktop} {
      grid-template-columns: 25% 25% 25% 25%;
    }
    @media ${(props) => `(min-width:${props.theme.breakpoints.large}) and (max-width: 1919px)`} {
      grid-template-columns: 25% 25% 25% 25%;
    }

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      grid-template-columns: auto;
    }
  }
  .other-stores-item {
    width: 100%;
  }
`;
